import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {useUpdateSetting} from '../../core/use-update-setting';

import {TAB_ACTIVITY, TAB_NOTE} from '../redux/consts';
import {setActionBarTab} from '../redux/core-entity-page-reducer';
import {getCoreEntityPageActionBarTab} from '../redux/core-entity-page-selectors';
import type {TabOption} from '../redux/types';

export function useActionBarFormTabSelection(settingName: string) {
    const updateSetting = useUpdateSetting();
    const dispatch = useDispatch();
    const actionBarTab = useSelector(getCoreEntityPageActionBarTab);

    const handleSelectFormTab = useCallback(
        (tab: TabOption) => {
            if (tab === TAB_NOTE || tab === TAB_ACTIVITY) {
                if (tab !== actionBarTab) {
                    updateSetting({
                        settingName,
                        value: tab,
                        isGlobal: false,
                    });
                }
                dispatch(setActionBarTab(tab));
            }
        },
        [actionBarTab, dispatch, settingName, updateSetting]
    );

    return {
        actionBarTab,
        handleSelectFormTab,
    };
}
